import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import {AutomationInputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationInputFileGraphQL';
import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';
import ShowAutomationFileErrorsButton from './ShowAutomationFileErrorsButton';

interface FailedRunAutomationFileButtonProps {
  automationFile: AutomationOutputFileGraphQL | AutomationInputFileGraphQL;
  isStale: boolean;
  runId: string | null;
  configName: string | null;
  locked: boolean;
  handleRefreshVersionedData: () => Promise<void>;
  updateAutomationOutputFiles: (automationOutputFiles: Array<AutomationOutputFileGraphQL>) => void;
  updateAutomationInputFile: (automationInputFile: AutomationInputFileGraphQL) => void;
  previousFileNames: Set<string>;
}

/**
 * This component represents an AutomationOutputFile with a FAILED status in a NoteLinkedAssayData.
 */
export default function FailedRunAutomationFileButton(
  props: FailedRunAutomationFileButtonProps
): JSX.Element {
  if (props.isStale) {
    return (
      <Button
        buttonStyle={ButtonStyle.NEGATIVE}
        size={ButtonSize.MINI}
        fullWidth={true}
        text="Failed - click to sync run"
        icon="warning"
        disabled={props.locked}
        onClick={props.handleRefreshVersionedData}
      />
    );
  }
  return (
    <ShowAutomationFileErrorsButton
      automationFile={props.automationFile}
      runId={props.runId}
      configName={props.configName}
      locked={props.locked}
      updateAutomationOutputFiles={props.updateAutomationOutputFiles}
      updateAutomationInputFile={props.updateAutomationInputFile}
      previousFileNames={props.previousFileNames}
    />
  );
}
